import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  max-width: ', 'px;\n  max-height: ', 'px;\n  margin: 0 auto ', 'px;\n  display: block;\n'], ['\n  max-width: ', 'px;\n  max-height: ', 'px;\n  margin: 0 auto ', 'px;\n  display: block;\n']);

import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme';

var Image = styled.img(_templateObject, function (props) {
  return props.maxWidth;
}, function (props) {
  return props.maxHeight;
}, gridSize() * 3);

export default Image;